import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../shared";

/**
 * Compact client summary shown in job header dropdowns.
 * @param {{ client?: { _id?: string, name?: string, avatar?: string, phone?: string, email?: string, address?: { fullAddress?: string } } }} props
 */
export const ClientCard = ({ client }) => {
  const navigate = useNavigate();
  const clientId = client?._id;

  const handleViewClientHistory = () => {
    if (!clientId) return;
    navigate(`/clients/${clientId}?invoice-show=Jobs`);
  };

  return (
    <>
      {/* Header with gradient background */}
      <div className="relative bg-gradient-to-r from-primary-500 to-primary-600 h-20">
        <div className="absolute -bottom-8 left-4">
          <div className="w-16 h-16 bg-white rounded-full border-4 border-white shadow-lg flex items-center justify-center">
            {client?.avatar ? (
              <img
                src={client.avatar}
                alt={client?.name}
                className="w-full h-full rounded-full object-cover"
              />
            ) : (
              <div className="w-full h-full bg-gray-100 rounded-full flex items-center justify-center">
                <span className="text-gray-400 text-lg font-semibold">
                  {client?.name?.charAt(0)?.toUpperCase() || "?"}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="pt-12 px-4 pb-4">
        <div className="mb-4">
          <h3 className="text-xl font-bold text-gray-900 mb-1">
            {client?.name}
          </h3>
          <div className="space-y-2">
            {client?.address?.fullAddress && (
              <div className="flex items-start text-sm text-gray-600">
                <svg
                  className="w-4 h-4 mt-0.5 mr-2 flex-shrink-0"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                    clipRule="evenodd"
                  />
                </svg>
                <span>{client.address.fullAddress}</span>
              </div>
            )}

            {client?.phone && (
              <div className="flex items-center text-sm text-gray-600">
                <svg
                  className="w-4 h-4 mr-2 flex-shrink-0"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                </svg>
                <span>{client.phone}</span>
              </div>
            )}

            {client?.email && (
              <div className="flex items-center text-sm text-gray-600">
                <svg
                  className="w-4 h-4 mr-2 flex-shrink-0"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                </svg>
                <span>{client.email}</span>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Footer Action */}
      <div className="border-t border-gray-100">
        <Button
          type="link"
          className="w-full text-center py-3 text-primary-600 hover:bg-primary-50 transition-colors duration-150 font-medium"
          onClick={handleViewClientHistory}
          disabled={!clientId}
        >
          View Client History
        </Button>
      </div>
    </>
  );
};
